<script lang="ts" setup>
  import type { PropType } from 'vue';
  import { useBreakpoints } from '@storefront/storefront';
  import { StoreLayout, AccountLayout } from '@storefront/components';

  defineOptions({
    layout: [StoreLayout, AccountLayout],
    inheritAttrs: false,
  });


  defineProps({
    url: { type: String, required: false },
    notifications: { type: Object as PropType<Notification>, required: true },
  });

  const breakpoints = useBreakpoints();
</script>
<template>
  <AccountMobileNavigation :href="$route('web.account.show')">
    {{ $t('SHOP.ACCOUNT.HEADER.NOTIFICATIONS') }}
  </AccountMobileNavigation>
  <FormController v-slot="{ processing, submit}" :action="$route('web.account.notifications.update')" :data="notifications" class="account-notifications" method="PATCH">
    <SfTile class="account-notifications__content" large>
      <template v-if="breakpoints.lg" #title>
        <h1 class="account__heading">
          {{ $t('SHOP.ACCOUNT.HEADER.NOTIFICATIONS') }}
        </h1>
      </template>
      <template #default>
        <div class="account-notifications__data">
          <div class="account-notifications__column">
            <h2 class="account-notifications__column-heading">
              {{ $t('SHOP.ACCOUNT.LABEL.NOTIFICATIONS_CHANGE_SETTINGS') }}
            </h2>
            <SfFormSwitch :label="$t('SHOP.ACCOUNT.LABEL.NOTIFICATION_REVIEW_REMINDER')" name="reviewReminder" />
          </div>
        </div>
      </template>
      <template #footer>
        <SfButton :loading="processing" class="account-notifications__submit" primary type="submit" @click="submit">
          {{ $t('SHOP.ACTION.SAVE') }}
        </SfButton>
      </template>
    </SfTile>
  </FormController>

  <RouterView />
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  .account-notifications {
    &__column-heading,
    &__newsletter-heading {
      font-size: 1.125rem;
    }

    &__data {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
    }

    &__column {
      display: flex;
      flex-direction: column;
      row-gap: 1.5rem;
    }

    &__newsletter {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }

  @include media.query(xl) {

    .account-notifications {
      &__column-heading,
      &__newsletter-heading {
        font-size: 1rem;
      }

      &__data {
        grid-template-columns: 1fr;
        gap: 2rem;
      }

      &__column {
        row-gap: 1.25rem;
      }

      &__newsletter {
        margin: 1rem 0;
        gap: 0.5rem;
      }

      &__submit {
        width: 100%;
      }
    }
  }


</style>
